import { render } from "./Comment.vue?vue&type=template&id=3361d91a&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=3361d91a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3361d91a"],['__file',"src/scripts/view/review/components/Comment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3361d91a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3361d91a', __exports__)) {
    api.reload('3361d91a', __exports__)
  }
  
  module.hot.accept("./Comment.vue?vue&type=template&id=3361d91a&scoped=true", () => {
    api.rerender('3361d91a', render)
  })

}


export default __exports__